import React, { useState,useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import useHygieneStore from "./store/hygieneStore";

const HygieneObservationModal = ({ show, handleClose, selectedObservation }) => {
  const { addHygieneObservation, fetchHygieneObservations, updateHygieneObservation } = useHygieneStore();
  const [loading, setLoading] = useState(false);
  // Validation Schema
  const validationSchema = Yup.object().shape({
    ObservationName: Yup.string()
      .trim()
      .min(3, "Observation Name must be at least 3 characters")
      .max(60, "Observation Name cannot exceed 60 characters")
      .required("Observation Name is required"),
    status: Yup.string().required("Please select a status"),
  });


  const handleSubmit = async (values, { resetForm, setErrors }) => {
    try {
      const formattedValues = {
        id: selectedObservation?.observationId, 
        ObservationName: values.ObservationName,
        isActive: values.status === "active", 
      };

      let result;
      if (selectedObservation?.observationId) {
        setLoading(true)
        result = await updateHygieneObservation(formattedValues);
      } else {
        setLoading(true)
        result = await addHygieneObservation(formattedValues);
        
      }

      if (result.success) {
        resetForm();
        fetchHygieneObservations();
        handleClose();
        setLoading(false)
      } else if (result.errors) {
        setLoading(false)
        // setErrors(result.errors); // Display validation errors from API
      }
    } catch (error) {
      console.error("Submission failed:", error);
      setLoading(false)
      setErrors({ general: "Something went wrong. Please try again." });
    }
  };


  let storedPermissions = localStorage.getItem("permissionId");
  const permissionValues1 =
    JSON.parse(localStorage.getItem("rolePermissions")) || {};
  let canWriteValue = null;

  // Convert storedPermissions to a number (if needed)
  storedPermissions = parseInt(storedPermissions, 10);

  // Find the matching roleToPermissionMapping object
  const matchingPermission = permissionValues1.find(
    (mapping) => mapping.permissionId === storedPermissions
  );

  if (matchingPermission) {
    canWriteValue = matchingPermission.canWrite;
    console.log(
      `canWrite value for permission ID ${storedPermissions}:`,
      canWriteValue
    );
  } else {
    console.log(`No match found for permission ID ${storedPermissions}`);
  }


  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header>
        <Modal.Title className="fw-bold">
          {selectedObservation ? "Edit Hygiene Observation" : "Add Hygiene Observation"}
        </Modal.Title>
        <i
          class="fa-solid fa-xmark close-container"
          onClick={handleClose}
        ></i>
      </Modal.Header>
      <hr />
      <Formik
        enableReinitialize
        initialValues={{
          ObservationName: selectedObservation?.observationName || "",
          status: selectedObservation?.isActive !== undefined ? (selectedObservation.isActive ? "active" : "inactive") : "active",
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ values, setFieldValue }) => (
          <Form>
            <Modal.Body>
              {/* Observation Name */}
              <div className="mb-3">
                <label className="fw-semibold">Observation Name <span className="text-danger">*</span></label>
                <Field
                  type="text"
                  name="ObservationName"
                  className="form-control"
                  placeholder="Enter Observation Name"
                  onChange={(e) => {
                    const { value } = e.target;
                    setFieldValue(
                      "ObservationName",
                      value
                        .replace(/[0-9]/g, "") // Removes numbers
                        .replace(/^\s+/, "") // Trims leading spaces
                        .replace(/\s{2,}/g, " ") // Replaces multiple spaces with a single space
                    );
                  }}
                  
                />
                <ErrorMessage
                  name="ObservationName"
                  component="div"
                  className="text-danger mt-1 small"
                />
              </div>

              {/* Status */}
              <div className="mb-3">
                <label className="fw-semibold">Status <span className="text-danger">*</span></label>
                <div className="d-flex align-items-center gap-3 form-group">
                  <label className="d-flex align-items-center form-check-label">
                    <Field type="radio" name="status" value="active" className="me-1" />
                    Active
                  </label>
                  <label className="d-flex align-items-center form-check-label">
                    <Field type="radio" name="status" value="inactive" className="me-1" />
                    InActive
                  </label>
                </div>
                <ErrorMessage
                  name="status"
                  component="div"
                  className="text-danger mt-1 small"
                />
              </div>
            </Modal.Body>

            {/* Submit Button */}
            <div className="modal-footer d-flex justify-content-center">
              {/* {canWriteValue === true ? ( */}
              <button
                type="submit"
                className="deployment-button"
              >


                {selectedObservation ?
                  loading ?
                    <l-bouncy
                      size="25"
                      speed="1.75"
                      color="white"
                    ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Update</> :
                  loading ?  <l-bouncy
                  size="25"
                  speed="1.75"
                  color="white"
                ></l-bouncy> : <> <i className="fa-solid fa-check done-container"></i> Submit </>}
              </button>
               {/* ) : (
                ""
              )} */}
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default HygieneObservationModal;
